var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestimonialWave5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 629,
    viewBox: "0 0 1440 629",
    width: 1440,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 903,
    x2: 873.524,
    y1: -36,
    y2: 458.472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f80031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487613,
    stopColor: "#c00e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a3c76"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1029.1 139.381c-212.801-81.8931-219.499 6.521-382.999 20.5s-297.612-138.6446-463-157.19075c-165.3885-18.54615-210.9787 64.16825-290.101 83.94895v542.3608h1653.6v-475.529s-304.31 67.953-517.5-14.09z",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialWave5);
export default __webpack_public_path__ + "static/media/testimonial-wave5.2ae471d3094a17e878e1888399df0033.svg";
export { ForwardRef as ReactComponent };